import ACTION from "../../actions";

const initialState = {
  OfferedCandidateProfileDetails: {},
  qualificationList: [],
  skillSetList: [],
  countryList: [],
  helpDeskData: {},
  loading: false,
  preferenceDetailedList: {},
  masterSkills: {},
};

/******************* 
@Purpose : Object containing paths for application
@Parameter : {}
@Author : INIC
******************/

const profileReducer = (state = initialState, actions) => {
  switch (actions.type) {
    case ACTION.START_LOADING:
      return { ...state, loading: true };

    case ACTION.STOP_LOADING:
      return { ...state, loading: false };

    case ACTION.OFFERCANDIDATE_ACTION_PROFILE:
      return {
        ...state,
        OfferedCandidateProfileDetails: actions.OfferedCandidateProfileDetails,
      };

    case ACTION.QUALIFICATION_DETAIL_LIST:
      return {
        ...state,
        qualificationList: actions.qualificationList,
      };

    case ACTION.SKILL_SET_LIST:
      return {
        ...state,
        skillSetList: actions.skillSetList,
      };
    case ACTION.COUNTRY_DETAIL_LIST:
      return {
        ...state,
        countryList: actions.countryDetailList,
      };
    case ACTION.OFFEREDCANDIDATE_HELP_DESK:
      return {
        ...state,
        helpDeskData: actions.helpDeskData,
      };
    case ACTION.GET_CANDIDATE_CV_DETAILS:
      return { ...state, getCandidateCvDetails: actions.CvInfo };
    case ACTION.MASTER_WORK_PREFERENCE_ACTION_DETAILS_LISTING:
      return {
        ...state,
        preferenceDetailedList: actions.preferenceDetailedList,
      };
    case ACTION.ADD_SKILLS_MASTER:
      return {
        ...state,
        masterSkills: actions.masterSkills,
      };
    default:
      return state;
  }
};

export default profileReducer;
